import { api } from '@/lib/api';
import type { PharmacyDetailsRequest, PharmacyDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/pharmacy';

export async function save_pharmacy_details(
  input: PharmacyDetailsRequest,
): Promise<PharmacyDetailsResponse> {
  const res = await api.post<PharmacyDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_pharmacy_details(): Promise<PharmacyDetailsResponse | null> {
  const res = await api.get<PharmacyDetailsResponse | null>(URL);
  return res.data;
}
